import React from "react";
import PropTypes from "prop-types";
import { Collapse } from "react-bootstrap";

export default function toggle(Component) {
  const Container = ({ open, ...rest }) => (
    <Collapse in={open}>
      <div>
        <Component {...rest} />
      </div>
    </Collapse>
  );

  Container.propTypes = {
    open: PropTypes.bool
  };

  return Container;
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/toggle.jsx